import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import AuthLayout from "../layouts/AuthLayout";
import ReviewOrder from '../pages/Checkout/ReviewOrder';      // ← ADD THIS
import Payment from '../pages/Checkout/Payment';              // ← ADD THIS
import OrderConfirmation from '../pages/OrderConfirmation/OrderConfirmation';
import Main from "../pages/Main/Main";
import Auth from "../pages/Auth/Auth";
import Community from "../pages/Community/Community";
import ProductDetail from "../pages/ProductDetail/ProductDetail";
import Shop from "../pages/Shop/Shop";
import Cart from "../pages/Cart/Cart"; // Make sure this is Cart, not CartPage
import Map from "../pages/Map/Map";
import Profile from "../pages/Profile/Profile";
import Orders from "../pages/Orders/Orders";
import PrivacyPolicy from "../pages/privacy/privacy";
import { ROUTES } from "./path";

export const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: <MainLayout />,
    children: [
      // Inside your routes array
      {
        path: ROUTES.CART,
        element: <div className="route-cart"><Cart /></div>
      },
      {
        path: ROUTES.REVIEW_ORDER,   // ← ADD THIS
        element: <div className="route-checkout"><ReviewOrder /></div>
      },
      {
        path: ROUTES.PAYMENT,        // ← ADD THIS
        element: <div className="route-checkout"><Payment /></div>
      },
      {
        path: ROUTES.ORDER_CONFIRMATION,
        element: <div className="route-order-confirmation"><OrderConfirmation /></div>
      },
      {
        index: true,
        element: <Main />
      },
      {
        path: ROUTES.COMMUNITY,
        element: <Community />
      },
      {
        path: ROUTES.MAP,
        element: <div className="route-map"><Map /></div>
      },
      {
        path: ROUTES.SHOP,
        element: <Shop />
      },
      {
        path: ROUTES.CART,
        element: <div className="route-cart"><Cart /></div>
      },
      {
        path: ROUTES.PROFILE,
        element: <div className="route-profile"><Profile /></div>
      },
      {
        path: ROUTES.ORDERS,
        element: <div className="route-orders"><Orders /></div>
      },
      {
        path: ROUTES.PRODUCT_DETAIL,
        element: <ProductDetail />
      },
      {
        path: ROUTES.ORDER_CONFIRMATION,
        element: <div className="route-order-confirmation"><OrderConfirmation /></div>
      },
      {
        path: ROUTES.PRIVACY_POLICY,
        element: <div className="route-privacy"><PrivacyPolicy /></div>
      }
    ]
  },
  {
    path: ROUTES.AUTH,
    element: <AuthLayout />,
    children: [
      {
        index: true,
        element: <Auth />
      }
    ]
  }
]);